import React from 'react';

import { ClientReportingMicroFrontend } from './ClientReportingPayoutsMFE';

export const ReportDashboardAdmin = () => (
  <ClientReportingMicroFrontend
    portalSection="reports"
    dataFd="client-reporting-dashboards-admin-micro-frontend"
  />
);

export default ReportDashboardAdmin;
